import { LoggerModule, ApiModule } from "@packages/common";
import type { Module } from "@webmotors/ioc";

import { DealerService } from "./dealer.service";

export const DealerModule: Module = {
  name: "DealerModule",
  modules: [ApiModule, LoggerModule],
  providers: [DealerService],
};
